<!--
  属性:
    defaultValueObj[Object]: 初始值对象 (此处通过vuex的analysisProjectsSettingData['Blast']传入)
  方法:
    updateBlastData(BlastForm): 提交Blast的数据 (此处调用vuex中的updateBlastData方法)
-->
<template>
  <div id="blast">
    <el-form ref="form" :model="blastForm" hide-required-asterisk>
      <el-row>
        <h3 class="config-title" style="margin-top:40px">
          <span v-if="blastVal === 'BLASTN'">Configuring search assemblies and Applications</span>
          <span v-else-if="blastVal === 'BLASTP'">Configure search calls and programs</span>
        </h3>
      </el-row>
      <el-form-item label="Database">
        <el-radio-group v-model="blastForm.database">
          <el-radio label="genome" v-if="blastVal === 'BLASTN'"></el-radio>
          <el-radio label="cds" v-if="blastVal === 'BLASTN'"></el-radio>
          <el-radio label="prot" v-if="blastVal === 'BLASTP'"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Optimize for" v-if="blastVal === 'BLASTN'">
        <el-radio-group
          v-model="blastForm.optimize"
          @change="handleOptimizeChange"
        >
          <el-radio label="megablast"
            >Optimize for Highly similar sequences (megablast)</el-radio
          >
          <el-radio label="dc-megablast"
            >More dissimilar sequences (discontiguous megablast)</el-radio
          >
          <el-radio label="blastn"
            >Optimize for Somewhat similar sequences (blastn)</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-row>
        <h3 class="config-title">General parameter configuration</h3>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="Max target sequence">
            <el-select v-model="blastForm.maxTargetSeq" style="width:100%">
              <el-option
                v-for="num in maxTargetSeqOpts"
                :label="num"
                :value="num"
                :key="num"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Word size">
            <el-select v-model="blastForm.wordSize" style="width:100%">
              <el-option
                v-for="num in wordSizeOpts"
                :label="num"
                :value="num"
                :key="num"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="Evalue">
            <el-input-number
              v-model="blastForm.threshold"
              :controls="false"
              class="long-num-input"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Max matches in a query range">
            <el-input-number
              v-model="blastForm.maxMatches"
              :controls="false"
              class="long-num-input"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <h3 class="config-title">Scoring parameter configuration</h3>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="Match/Mismatch scores" v-if="blastVal === 'BLASTN'">
            <el-select v-model="matchScoresVal" style="width:100%" @change="matchScoresChange">
              <el-option
                v-for="num in matchScoresOpts"
                :label="num"
                :value="num"
                :key="num"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Matrix" v-if="blastVal === 'BLASTP'">
            <el-select v-model="blastForm.matrix" style="width:100%" @change="matchScoresChange">
              <el-option
                v-for="num in matrixOpts"
                :label="num"
                :value="num"
                :key="num"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Gap costs" label-position="top">
            <el-select v-model="gapCostsVal" style="width:100%">
              <el-option
                v-for="item in gapCostsOpts"
                :label="item"
                :value="item"
                :key="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40" v-if="blastVal === 'BLASTP'">
        <el-col :span="12">
          <el-form-item label="Compositional adjustments" v-if="blastVal === 'BLASTP'">
            <el-select v-model="blastForm.compositional" style="width:100%">
              <el-option
                v-for="(item,index) in compositionalOpts"
                :label="item"
                :value="index"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import { mapState, mapMutations } from 'vuex'
import http from '../utils/http'
export default {
  name: 'Blast',
  data () {
    return {
      blastForm: {},
      defaultValueObj: {},
      maxTargetSeqOpts: [],
      wordSizeOpts: [],
      matchScoresOpts: [],
      matchScoresVal: 0,
      gapCostsOpts: [],
      gapCostsVal: 0,
      matrixOpts: [],
      compositionalOpts: []
    }
  },
  created () {
    // this.init()
    this.getSettingData()
    // this.actions
  },
  methods: {
    ...mapMutations(['updateBlastData']),
    async getSettingData () {
      let url = '../../static/setting.json'
      // if (process.env.NODE_ENV === 'production') url = '/gosweb/experiment/dist' + url
      try {
        let response = await fetch(url)
        this.defaultValueObj = await response.json()
        this.init()
      } catch (error) {
        // console.log('Request Failed', error)
      }
    },
    init () {
      if (this.blastVal === 'BLASTN') {
        this.blastForm = {
          library: '',
          database: '',
          optimize: '',
          maxTargetSeq: 0,
          wordSize: 0,
          threshold: 0,
          maxMatches: 0,
          matchScoresFrom: 0,
          matchScoresTo: 0,
          gapCostsFrom: 0,
          gapCostsTo: 0
        }
      } else if (this.blastVal === 'BLASTP') {
        this.blastForm = {
          library: '',
          database: '',
          maxTargetSeq: 0,
          wordSize: 0,
          threshold: 0,
          maxMatches: 0,
          matrix: 0,
          gapCostsFrom: 0,
          gapCostsTo: 0,
          compositional: 0
        }
      }
      this.initValue()
      this.initOpts()
      this.geteLibraryId(this.blastForm.library)
    },
    initValue () {
      if (this.blastVal === 'BLASTN') {
        for (let key in this.blastForm) {
          this.blastForm[key] = this.defaultValueObj[key]
            ? (this.defaultValueObj[key].defaultValue || '')
            : ''
        }
        this.matchScoresVal = this.blastForm.matchScoresFrom + ',' + this.blastForm.matchScoresTo
      } else if (this.blastVal === 'BLASTP') {
        for (let key in this.blastForm) {
          if (key !== 'gapCostsFrom' || key !== 'gapCostsTo') {
            if (this.defaultValueObj[key] && this.defaultValueObj[key]['blastp']) {
              this.blastForm[key] = this.defaultValueObj[key]['blastp']['defaultValue']
            } else {
              this.blastForm[key] = this.defaultValueObj[key]['defaultValue']
            }
          }
        }
        // this.gapCostsVal = 'Existence:' + this.blastForm.gapCostsFrom + ' Extension:' + this.blastForm.gapCostsTo
      }
    },
    initOpts () {
      if (this.blastVal === 'BLASTN') {
        for (let key of ['maxTargetSeqOpts', 'wordSizeOpts']) {
          this[key] = this.defaultValueObj[key].defaultValue
            .split(',')
            .map(i => i * 1)
        }
        this['matchScoresOpts'] = this.defaultValueObj['matchScoresOpts'].defaultValue
      } else if (this.blastVal === 'BLASTP') {
        for (let key of ['maxTargetSeqOpts', 'wordSizeOpts']) {
          if (this.defaultValueObj[key] && this.defaultValueObj[key]['blastp']) {
            this[key] = this.defaultValueObj[key]['blastp']['defaultValue'].split(',').map(i => i * 1)
          } else {
            this[key] = this.defaultValueObj[key]['defaultValue'].split(',').map(i => i * 1)
          }
        }
        for (let key of ['matrixOpts', 'compositionalOpts']) {
          if (this.defaultValueObj[key] && this.defaultValueObj[key]['blastp']) {
            this[key] = this.defaultValueObj[key]['blastp']['defaultValue'].split(',')
          } else {
            this[key] = this.defaultValueObj[key]['defaultValue'].split(',')
          }
        }
      }
      this.matchScoresChange()
    },
    matchScoresChange () {
      if (this.blastVal === 'BLASTN') {
        // 更换默认值
        if (this.matchScoresVal === '4,-5') {
          this.blastForm['gapCostsFrom'] = this.defaultValueObj['gapCostsFrom']['relationMSP'][this.matchScoresVal]
          this.blastForm['gapCostsTo'] = this.defaultValueObj['gapCostsTo']['relationMSP'][this.matchScoresVal]
        } else {
          this.blastForm['gapCostsFrom'] = this.defaultValueObj['gapCostsFrom']['defaultValue']
          this.blastForm['gapCostsTo'] = this.defaultValueObj['gapCostsTo']['defaultValue']
        }
        if (this.blastVal === 'BLASTN' && this.blastForm.optimize === 'megablast' && this.matchScoresVal === '2,-3') {
          this.blastForm['gapCostsFrom'] = this.defaultValueObj['gapCostsFrom']['relationMSP'][this.matchScoresVal]
          this.blastForm['gapCostsTo'] = this.defaultValueObj['gapCostsTo']['relationMSP'][this.matchScoresVal]
        }
        // if (this.blastForm.gapCostsFrom === -1 && this.blastForm.gapCostsTo === -1) {
        //   this.gapCostsVal = 'Linear'
        // } else {
        //   this.gapCostsVal = 'Existence:' + this.blastForm.gapCostsFrom + ' Extension:' + this.blastForm.gapCostsTo
        // }
        // 更换选项
        this['gapCostsOpts'] = this.defaultValueObj['gapCostsOpts']['relationMSP'][this.matchScoresVal].slice(0)
        // if (this.blastForm.optimize === 'megablast' && this.matchScoresVal !== '1,-1') {
        //   this['gapCostsOpts'].unshift('Linear')
        // }
      } else if (this.blastVal === 'BLASTP') {
        this.blastForm['gapCostsFrom'] = this.defaultValueObj['gapCostsFrom']['blastp'][this.blastForm.matrix]
        this.blastForm['gapCostsTo'] = this.defaultValueObj['gapCostsTo']['blastp'][this.blastForm.matrix]
        this['gapCostsOpts'] = this.defaultValueObj['gapCostsOpts']['blastp'][this.blastForm.matrix].slice(0)
      }
      this.gapCostsVal = 'Existence:' + this.blastForm.gapCostsFrom + ' Extension:' + this.blastForm.gapCostsTo
    },
    handleOptimizeChange (label) {
      this.updateInitialValue('optimize', label)
    },
    updateInitialValue (key, value) {
      const settingObj = this.defaultValueObj
      for (let i in settingObj) {
        if (
          typeof settingObj[i] === 'object' &&
          'specialConditions' in settingObj[i] &&
          i !== 'gapCostsOpts'
        ) {
          const scObj = settingObj[i]['specialConditions']
          if (value in scObj[key]) {
            if (i.indexOf('Opts') > -1) {
              this[i] = scObj[key][value].split(',').map(i => i * 1)
            } else {
              this.blastForm[i] = scObj[key][value]
            }
          } else {
            if (i.indexOf('Opts') > -1) {
              this[i] = settingObj[i].defaultValue.split(',').map(i => i * 1)
            } else {
              this.blastForm[i] = settingObj[i].defaultValue
            }
          }
        }
      }
      this.matchScoresVal = this.blastForm.matchScoresFrom + ',' + this.blastForm.matchScoresTo
      this.matchScoresChange()
    },
    geteLibraryId (library) {
      http.get(`/base/getSeqBaseLibrary`, {}, res => {
        if (res.code === 200) {
          let arr = res.data.filter(i => i.name === library)
          if (arr.length === 0) {
            Message.error('LibraryId Not Found')
            this.blastForm.library = ''
          } else {
            this.blastForm.library = arr[0].id
          }
        }
      })
    }
  },
  computed: {
    ...mapState(['blastVal'])
  },
  watch: {
    blastForm: {
      handler () {
        this.updateBlastData(this.blastForm)
      },
      deep: true
    },
    matchScoresVal: {
      handler (newVal) {
        let val = newVal.split(',')
        this.blastForm.matchScoresFrom = val[0]
        this.blastForm.matchScoresTo = val[1]
      }
    },
    gapCostsVal: {
      handler (newVal) {
        // if (newVal === 'Linear') {
        //   this.blastForm.gapCostsFrom = -1
        //   this.blastForm.gapCostsTo = -1
        // } else {
        let val = newVal.split(' ')
        this.blastForm.gapCostsFrom = val[0].substring(val[0].indexOf(':') + 1, val[0].length)
        this.blastForm.gapCostsTo = val[1].substring(val[1].indexOf(':') + 1, val[1].length)
        // }
      }
    },
    blastVal: {
      handler () {
        this.init()
      }
    }
  }
}
</script>
<style scoped>
.el-form {
  padding-top: 20px;
  width: 85%;
  font-size: 14px;
}
.el-form-item >>> .el-form-item__label {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}
.el-form-item >>> .el-form-item__label_wrap,
.el-form-item >>> .el-form-item__content {
  margin-left: 0 !important;
}
.el-radio-group {
  display: block;
  margin-left: 120px;
}
.el-radio-group .el-radio {
  line-height: 40px;
}
.el-radio-group .el-radio >>> .el-radio__input.is-checked .el-radio__inner{
  border-color: #05579e;
  background: #05579e;
}
.el-radio >>> .el-radio__input.is-checked + .el-radio__label {
  color: #606266;
}
.config-title {
  margin-top: 30px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}
.el-input-number {
  display: block;
}
.long-num-input {
  width: 100%;
}
.long-num-input >>> .el-input__inner {
  text-align: left;
}
.long-num-input >>> .el-input.is-active .el-input__inner, .long-num-input >>> .el-input__inner:focus, .el-select >>> .el-input.is-focus .el-input__inner, .el-select >>> .el-input__inner:focus{
  border-color: #05579e;
}
</style>



// WEBPACK FOOTER //
// src/components/Blast.vue